import React from 'react'
import { css } from '@emotion/core'
import { useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

import { PersonType } from '../../../../../propTypes/personDataProps'

import PersonRelationship from '../PersonRelationship/PersonRelationship'
import PersonTimelineDetails from './components/PersonTimelineDetails/PersonTimelineDetails'

export default function PersonTimeline({ personData, tree, locationLookup, initialPerson, onPersonClick }) {
  const [t] = useTranslation()
  const atSize = useAtSize()

  const treeHeader = css`
    margin: 20px 0 23px 0;
    text-align: center;
    color: #212225;
    font-size: 1rem;
  `

  const containerCSS = css`
    display: flex;
    height: auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  `

  const leftContainerCSS = css`
    ${atSize({ lg: 'padding-left: 30px' })};
    background-color: #fff;
    float: left;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  `

  const rightContainerCSS = css`
    ${atSize({ default: 'overflow-x: show', xl: 'margin: 0' })};
    background-color: #fff;
    padding-top: 20px;
    float: left;
    flex: 2;
  `

  return (
    <div css={containerCSS}>
      {atSize({
        xl:
          tree && tree.length ? (
            <div css={leftContainerCSS}>
              <p css={treeHeader}>{t('person-details.relationship', 'Relationship')}</p>
              <PersonRelationship
                personData={personData}
                tree={tree}
                initialPerson={initialPerson}
                onPersonClick={onPersonClick}
              />
            </div>
          ) : (
            <></>
          ),
      })}
      <div css={rightContainerCSS}>
        <PersonTimelineDetails personData={personData} tree={tree} locationLookup={locationLookup} />
      </div>
    </div>
  )
}

PersonTimeline.propTypes = {
  personData: PersonType,
}
